import React from 'react'
import styled, { css } from 'styled-components'
import { Icon, Checkbox } from 'gipsy-ui'
import { utils, translations, styles } from 'gipsy-misc'

const CHECKBOX_SIZE = 16

const ReviewStar = ({ isCompleted }) =>
  isCompleted ? (
    <Icon style={{ marginRight: 10 }} fill={styles.colors.textDarkColor} className="review-star" icon={'Star'} />
  ) : (
    <Icon
      style={{ marginRight: 10 }}
      size={CHECKBOX_SIZE}
      fill={'none'}
      stroke={styles.colors.darkGrey}
      className="review-star"
      icon={'StarOutlined'}
    />
  )

/* Event Content for Day view */
export const CalendarItemDayContent = ({ event, isAllDay, onComplete }) => {
  const now = new Date()
  const isPast = event.end < now
  const isTask = event.item.type === 'task'
  const isCompleted = event.item.completed === 1
  const isReviewTask = utils.task.isReviewTask(event.item)
  return (
    <CalendarItem className="calendar-day-item-content" isPast={isPast}>
      {isTask ? (
        isReviewTask ? (
          <ReviewStar isCompleted={isCompleted} />
        ) : (
          <CheckboxContainer>
            <Checkbox
              id={event.item.id}
              extraSpace={15}
              offsetTop={2}
              size={CHECKBOX_SIZE}
              borderRadius={6}
              paramName="completed"
              checked={!!event.item.completed}
              onChange={onComplete}
              checkmarkWidth={6}
              checkmarkHeight={8}
              checkmarkLeft={3}
              checkmarkTop={1}
            />
          </CheckboxContainer>
        )
      ) : (
        ''
      )}
      <CalendarItemText>{event.item.title || translations.task.new}</CalendarItemText>
    </CalendarItem>
  )
}

/* Event Content for Week view */
export const CalendarItemWeekContent = ({ event }) => {
  const now = new Date()
  const isPast = event.end < now
  return (
    <CalendarItem className="calendar-day-item-content" isPast={isPast}>
      <CalendarItemText>{event.item.title || translations.task.new}</CalendarItemText>
    </CalendarItem>
  )
}

const CheckboxContainer = styled.div`
  width: ${CHECKBOX_SIZE + 10}px;
  height: ${CHECKBOX_SIZE + 4}px;
`

const CalendarItem = styled.div`
  font-size: ${styles.fonts.fontSizeXSmall};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  opacity: ${props => (props.isPast ? 0.4 : 1)};
`

const CalendarItemText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

/* Event Content for all views */
export const CalendarItemContent = ({ event }) => {
  return <CalendarItem className="calendarItem-content">{event.item.title || translations.task.new}</CalendarItem>
}

/* Wrapper around Time column header (All day) */
export const TimeGutterHeader = props => {
  return <AllDayCell className="time-gutter-header">ALL DAY</AllDayCell>
}

const AllDayCell = styled.div`
  color: ${styles.colors.darkGrey};
  font-size: ${styles.fonts.fontSizeXSmall};
  line-height: 28px;
  text-transform: uppercase;
  text-align: center;
`

/* Wrapper around Time cell content (left column) */
export const TimeSlotWrapper = ({ children, value }) => {
  const date = new Date(value)
  let hideTimeSlotLabel = false
  if (date.getMinutes() === 30) {
    hideTimeSlotLabel = true
  }
  return (
    <TimeSlot hideTimeSlotLabel={hideTimeSlotLabel} className="time-slot-wrapper">
      {children}
    </TimeSlot>
  )
}

const TimeSlot = styled.div`
  && {
    color: ${styles.colors.darkGrey};
    font-size: ${styles.fonts.fontSizeXSmall};
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    ${props =>
      props.hideTimeSlotLabel &&
      css`
        .rbc-label {
          display: None;
        }
      `}
    .rbc-time-slot {
      border-top: None;
    }
  }
`



// WEBPACK FOOTER //
// ./src/features/calendar/components.js